import { nsMerchantUser } from '@/app/i18n/namespaces';
import MERCHANT_USER_STATUS from '../enums/MerchantUserStatus';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    EMAIL: {
        key: 'email',
        type: 'text',
        entity: 'keys.email',
        namespace: nsMerchantUser,
        placeholder: 'filter.placeholder.email',
        enableSorting: true,
        filter: 'input'
    },
    IS_ADMIN: {
        key: 'isAdmin',
        type: 'text',
        entity: 'contract_access_user_role'
    },
    MERCHANT_PROFILE: {
        key: 'merchantProfile',
        type: 'text',
        entity: 'keys.profile',
        namespace: nsMerchantUser,
        prefix: 'profile.',
        enableSorting: false
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        namespace: nsMerchantUser,
        entity: 'keys.created_at',
        enableSorting: true,
        filter: 'date'
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: 'date',
        namespace: nsMerchantUser,
        entity: 'keys.updated_at',
        enableSorting: true,
        filter: 'date'
    },
    STATUS: {
        key: 'status',
        type: 'select',
        namespace: nsMerchantUser,
        prefix: 'contract_access_status_',
        entity: 'keys.status',
        filter: 'select',
        enum: MERCHANT_USER_STATUS,
        enableSorting: true
    },
    LAST_LOGIN_AT: {
        key: 'lastLoginAt',
        type: 'date',
        entity: 'keys.last_login_at',
        namespace: nsMerchantUser,
        enableSorting: true,
        filter: 'date'
    },
    PROFILE_NAME: {
        key: 'name'
    },
    PROFILE_PERMISSIONS: {
        key: 'permissions'
    }
};